export default __webpack_public_path__ + "static/media/MainGreenhouseGasesSBI.468f94e4.jpg";